import type { CoordinateInputSuggestion } from './coordinateInputAssist'

// suffix displayed inline (Safari / keyboard predictions) ; Tab or → to accept
export function pickInlineSearchCompletion(
  query: string,
  recentShown: string[],
  coordSuggestions: CoordinateInputSuggestion[],
): { full: string; suffix: string } | null {
  const q = query
  if (!q.trim()) return null

  for (const r of recentShown) {
    if (r.length <= q.length) continue
    if (!r.toLowerCase().startsWith(q.toLowerCase())) continue
    return { full: r, suffix: r.slice(q.length) }
  }

  for (const s of coordSuggestions) {
    const full = s.applyFull?.trim()
    if (!full || full.length <= q.length) continue
    if (!full.toLowerCase().startsWith(q.toLowerCase())) continue
    return { full, suffix: full.slice(q.length) }
  }

  return null
}
